import React from 'react';

const Page_404 = () => {

    return <div>
      <h1>Hups, sivua ei löytynyt!</h1>
    </div>
}
export default Page_404;
